import { makeStyles, styled } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(1, 0, 2),
    zIndex: 1200,
    pointerEvents: 'none',
  },
  toolbar: {
    pointerEvents: 'auto',
  },
  menuContainer: {
    position: 'relative',
  },
  button: {
    color: 'var(--text-base)',
    borderRadius: 'var(--encore-corner-radius-base)',
    width: 40,
    height: 40,
  },
  buttonActive: {
    backgroundColor: 'var(--essential-bright-accent)',
    color: '#000', // TODO(encore): use .encore-bright-accent-set class + var(--text-base)
    '&:hover': {
      backgroundColor: 'var(--essential-bright-accent)',
    },
  },
  popover: {
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    marginBottom: theme.spacing(1),
    zIndex: 9999,
  },
}));

export const Menu = styled('ul')({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  maxHeight: 400,
  overflowY: 'auto',
});

export const MenuItem = styled('li')({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  gap: 'var(--encore-spacing-tighter)',
  padding: 'var(--encore-spacing-tighter-2)',
  whiteSpace: 'nowrap',
  '&:hover, &.selected': { background: 'var(--background-tinted-highlight)' },
  '&:active': { background: 'var(--background-tinted-press)' },
  '&.disabled': { color: 'var(--essential-subdued)', cursor: 'default' },
  '&.disabled:hover': { background: 'none' },
});

export const MenuItemIcon = styled('span')({
  alignItems: 'center',
  display: 'flex',
  color: 'var(--text-subdued)',
  justifyContent: 'center',
});

export const SubmenuIndicator = styled('span')({
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
});

export const MenuDivider = styled('li')({
  borderTop: '1px solid var(--decorative-subdued)',
  margin: 'var(--encore-spacing-tighter-4) 0',
  listStyle: 'none',
});
